export default __webpack_public_path__ + "static/media/azure-devops.e42f57f0.svg";